import { render, staticRenderFns } from "./MoreAboutWidget.html?vue&type=template&id=baf2c760&"
import script from "./MoreAboutWidget.vue?vue&type=script&lang=ts&"
export * from "./MoreAboutWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports